var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSection1Icon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 14H16C15.4696 14 14.9609 14.2107 14.5858 14.5858C14.2107 14.9609 14 15.4696 14 16V20.54",
    stroke: "#00AFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.34003V4.00003C6 4.79568 6.31607 5.55874 6.87868 6.12135C7.44129 6.68396 8.20435 7.00003 9 7.00003C9.53043 7.00003 10.0391 7.21074 10.4142 7.58581C10.7893 7.96089 11 8.46959 11 9.00003C11 10.1 11.9 11 13 11C13.5304 11 14.0391 10.7893 14.4142 10.4142C14.7893 10.0392 15 9.53046 15 9.00003C15 7.90003 15.9 7.00003 17 7.00003H20.17",
    stroke: "#00AFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9998 20.95V17C9.9998 16.4696 9.78909 15.9609 9.41402 15.5858C9.03894 15.2107 8.53024 15 7.9998 15C7.46937 15 6.96066 14.7893 6.58559 14.4142C6.21052 14.0391 5.9998 13.5304 5.9998 13V12C5.9998 11.4696 5.78909 10.9609 5.41402 10.5858C5.03895 10.2107 4.53024 10 3.9998 10H1.0498",
    stroke: "#00AFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
    stroke: "#00AFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection1Icon3);
export default __webpack_public_path__ + "static/media/home-section1-icon3.44d34fe5f3ff0f239b1dacef7840c374.svg";
export { ForwardRef as ReactComponent };